import React from "react";
import { Fade } from "react-reveal";

const Contact = () => {
  return (
    <div className="contact-div" id="contact">
      <div className="head mx-5">
        <div className="main-div">
          <Fade top cascade>
            <section className="div-1 contact">
              <h1 className="my-3 heading" style={{ textAlign: "center" }}>
                Get In Touch
              </h1>
              <p>
                I am open to new opportunities. Send a message and I will get
                back to you.
              </p>
              <p className="contact-meta">
                <a href="tel:+919458708025">+91-9458708025</a>
                <span aria-hidden="true"> · </span>
                <a href="mailto:deepak2707.bbk@gmail.com">
                  deepak2707.bbk@gmail.com
                </a>
              </p>
              <a
                href="mailto:deepak2707.bbk@gmail.com"
                className="button btn btn-outline-success my-3"
              >
                Say Hello
              </a>
            </section>
          </Fade>
          <p className="footer">Designed and Built by Deepak Singh</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
